import React, {FC} from 'react'

export const MarkdownIcon: FC = () => (
    <svg className='canvas-toolbar__icon' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
        <rect x='2' y='4' width='20' height='16' rx='2'/>
        <path d='M6 16V8l3 4 3-4v8'/>
        <path d='M17 12h-2v4h-1.5c-.83 0-1.5-.67-1.5-1.5v-2.5h1.5'/>
        <line x1='17' y1='8' x2='17' y2='16'/>
    </svg>
)
